/*
 * BeeCaramulo Apiturismo - v0.1.0
 * Author: truebond.pt
 * 
 * CheckScreen.js
 */

import { useEffect, useState } from 'react';

const CheckScreen = (widthValue) => {
    const [width, setWidth] = useState(window.innerWidth);
    const handleWindowSizeChange = () => {
            setWidth(window.innerWidth);
    }

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);

        // Cleanup
        return () =>  window.removeEventListener('resize', handleWindowSizeChange);
    }, []);

    return (width <= widthValue);
}

export default CheckScreen;